module.exports = __webpack_public_path__ + "img/texture_0.63304a1b.png";